/**
 * Pubsub.js
 * Create a system to subscribe to Ajax interactions
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */
(function($){
    /**
     * JQuery Object reference
     */
    var o = $({});

    /**
     * Listen to Events
     */
    $.subscribe = function(){
        o.on.apply(o, arguments);
    };

    /**
     * Stop Listening to Events
     */
    $.unsubscribe = function(){
        o.off.apply(o, arguments);
    };

    /**
     * Trigger Events
     */
    $.publish = function(){
        o.trigger.apply(o, arguments);
    };

}(jQuery));
